import React, { useEffect, useState } from "react";

export default function AnalyzerRatioGauge({
    deviceId,
    type = "end", // "end" = endüktif, "cap" = kapasitif
    title = "Oran",
    deviceType = "analyzer", // "analyzer" veya "reactive"
}) {
    const API_BASE = process.env.REACT_APP_API_BASE_URL;

    const [value, setValue] = useState(0);

    // ============================
    // 🎯 API'DEN ÇEK
    // ============================
    useEffect(() => {
        async function load() {
            try {
                // Cihaz tipine göre doğru endpoint'i seç
                const endpoint = deviceType === "reactive"
                    ? `${API_BASE}/reactive/ratios?deviceId=${deviceId}`
                    : `${API_BASE}/measurements/ratios?deviceId=${deviceId}`;

                const res = await fetch(endpoint);
                const json = await res.json();

                // type göre backend alanı seç
                let raw;
                if (type === "end") {
                    raw = Number(json?.tanPhiEnd ?? 0);

                } else {
                    raw = Math.abs(Number(json?.tanPhiCap ?? 0));
                }

                setValue(raw);
            } catch (err) {
                console.error("Ratio fetch error:", err);
            }
        }

        load();
        const t = setInterval(load, 3000);
        return () => clearInterval(t);
    }, [API_BASE, deviceId, type, deviceType]);

    // ============================
    // GAUGE HESAPLAMALARI
    // ============================

    // 20 ÜSTÜ clamp → FULLDE dursun
    const v = Math.min(20, Math.max(0, value));

    const polar = (cx, cy, r, deg) => {
        const rad = (deg * Math.PI) / 180;
        return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
    };

    const START = 210;
    const END = -30;
    const SPAN = START - END;
    const DEG = SPAN / 20;

    const SIZE = 260;
    const STROKE = 22;
    const R = (SIZE - STROKE) / 2;
    const CX = SIZE / 2;
    const CY = SIZE / 2;

    const arcPath = (a1, a2) => {
        const p1 = polar(CX, CY, R, a1);
        const p2 = polar(CX, CY, R, a2);
        const large = Math.abs(a2 - a1) > 180 ? 1 : 0;
        return `M ${p1.x} ${p1.y} A ${R} ${R} 0 ${large} 0 ${p2.x} ${p2.y}`;
    };

    const greenEnd = START - DEG * 12;
    const yellowEnd = START - DEG * 16;

    const pivot = { x: CX, y: CY };

    const angle = START - v * DEG;

    const tip = polar(CX, CY, R * 0.78, angle);
    const side1 = polar(CX, CY, R * 0.72, angle + 6);
    const side2 = polar(CX, CY, R * 0.72, angle - 6);

    // MERKEZ DAİRE RENGİ
    let centerColor = "#22c55e"; // yeşil
    if (v > 16) centerColor = "#ef4444";      // kırmızı
    else if (v > 12) centerColor = "#facc15"; // sarı

    return (
        <div className="flex flex-col items-center bg-white p-4 rounded-xl border shadow-sm">
            <h3 className="text-sm font-semibold text-slate-700 mb-2">{title}</h3>

            <svg viewBox={`0 0 ${SIZE} ${SIZE}`} className="w-full h-auto max-w-[260px]">
                <g transform={`scale(1,-1) translate(0, -${SIZE})`}>
                    <path
                        d={arcPath(START, greenEnd)}
                        stroke="#22c55e"
                        strokeWidth={STROKE}
                        strokeLinecap="round"
                        fill="none"
                    />

                    <path
                        d={arcPath(greenEnd, yellowEnd)}
                        stroke="#facc15"
                        strokeWidth={STROKE}
                        strokeLinecap="round"
                        fill="none"
                    />

                    <path
                        d={arcPath(yellowEnd, END)}
                        stroke="#ef4444"
                        strokeWidth={STROKE}
                        strokeLinecap="round"
                        fill="none"
                    />

                    {/* NEEDLE */}
                    <polygon
                        points={`${pivot.x},${pivot.y}  ${side1.x},${side1.y}  ${tip.x},${tip.y}  ${side2.x},${side2.y}`}
                        fill="#374151"
                    />

                    <circle cx={pivot.x} cy={pivot.y} r="7" fill="#374151" />
                </g>

                {/* ORTA DAİRE */}
                <g transform={`translate(${CX - 45}, ${CY - 45})`}>
                    <circle cx="45" cy="45" r="40" fill={centerColor} />
                    <text
                        x="45"
                        y="50"
                        textAnchor="middle"
                        fontSize="22"
                        fontWeight="700"
                        fill="#111827"
                    >
                        %{value.toFixed(0)}

                    </text>
                </g>
            </svg>
        </div>
    );
}
